export enum MannerOfDeath {
    NATURAL = "Natural",
    ACCIDENT = "Accident",
    SUICIDE = "Suicide",
    HOMICIDE = "Homicide",
    UNKNOWN = "Unknown"
}